import React from 'react';
import PropTypes from 'prop-types';
import { palette } from '@m12s/component-library';
import BaseModal from 'components/BaseModal';
import { ModalButton } from 'components/BaseModal/styled';

const ConfirmDialog = ({
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}) => {
  return (
    <BaseModal
      isOpen
      onClose={onCancel}
      header={title}
      details={message}
      buttons={[
        <ModalButton
          key="confirm-dialog-cancel"
          variant="inferior"
          onClick={() => {
            return onCancel();
          }}
        >
          {cancelText}
        </ModalButton>,
        <ModalButton
          key="confirm-dialog-confirm"
          customStyles={{
            backgroundColor: palette.Indigo600,
          }}
          hoverStyles={{
            backgroundColor: palette.Indigo700,
          }}
          onClick={() => {
            return onConfirm();
          }}
        >
          {confirmText}
        </ModalButton>,
      ]}
    />
  );
};

ConfirmDialog.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

export default ConfirmDialog;
